import {
  MutationBitbucketCloudIntegrationUpdateV2Args,
  MutationBitbucketCloudIntegrationCreateV2Args,
  VcsCheck,
} from "types/generated";
import { ROOT_SPACE_ID } from "constants/space";

import { ManageBitbucketCloudFormFieldsV2 } from "../types";
import { VCS_INTEGRATION_TYPES } from "../../../constants";
import { BitbucketCloudIntegrationData } from "../Edit/gql";

export const getFormDefaultValues = (
  integration?: BitbucketCloudIntegrationData
): ManageBitbucketCloudFormFieldsV2 => {
  const useGitCheckoutValue = integration ? integration?.useGitCheckout : true;
  return {
    apiToken: "",
    email: integration?.email || "",
    name: integration?.name || "",
    space: integration?.space?.id || "",
    integrationType: integration?.isDefault
      ? VCS_INTEGRATION_TYPES.DEFAULT
      : VCS_INTEGRATION_TYPES.MULTIPLE,
    labels: integration?.labels?.map((label) => ({ value: label })) || [],
    description: integration?.description || "",
    vcsChecks: integration?.vcsChecks || VcsCheck.Individual,
    useGitCheckout: useGitCheckoutValue,
  };
};

export const mapCreateIntegrationInputValues = (
  values: ManageBitbucketCloudFormFieldsV2
): MutationBitbucketCloudIntegrationCreateV2Args => {
  const isDefault = values.integrationType === VCS_INTEGRATION_TYPES.DEFAULT;

  return {
    input: {
      apiToken: values.apiToken.trim(),
      email: values.email.trim(),
      customInput: {
        isDefault,
        name: values.name.trim(),
        labels: values.labels.map((label) => label.value) || [],
        spaceID: isDefault ? ROOT_SPACE_ID : values.space,
        description: values.description?.trim() || null,
        vcsChecks: values.vcsChecks,
        useGitCheckout: values.useGitCheckout,
      },
    },
  };
};

export const mapUpdateIntegrationInputValues = (
  values: ManageBitbucketCloudFormFieldsV2,
  integrationId: string
): MutationBitbucketCloudIntegrationUpdateV2Args => ({
  input: {
    apiToken: values.apiToken?.trim() || null,
    email: values.email.trim(),
    customInput: {
      id: integrationId,
      labels: values.labels.map((label) => label.value) || [],
      space: values.space,
      description: values.description?.trim() || null,
      vcsChecks: values.vcsChecks,
      useGitCheckout: values.useGitCheckout,
    },
  },
});
